export default "__VITE_ASSET__e99a804f__$_?nuxt_component=async&nuxt_component_name=SvgoFreematic__"